export { VariablesPage } from "./ui/variables-page"
